import { Trash2 } from 'lucide-react';
import { TagRevenu } from '../types';
import { BadgeTagRevenu } from './TagScenarioRevenu';
import { fmtMoisFr } from '../utils/format';

/**
 * Historique d'événements « dès tel mois » (montants, quantités, tarifs,
 * décomptes…) : tableau trié du plus récent au plus ancien, avec suppression
 * optionnelle (absente = lecture seule).
 */
export function HistoriqueRevenu({ titre, lignes, onSupprimer }: {
  titre?: string; // omis quand l'appelant compose lui-même son en-tête
  lignes: Array<{ id: number; mois: string; valeur: string; tag: TagRevenu; scenarioNom: string | null; commentaire: string }>;
  onSupprimer?: (id: number) => void;
}) {
  return (
    <div style={{ flex: 1, minWidth: 0 }}>
      {titre && <h3 className="text-base font-semi mb-8">{titre}</h3>}
      <table className="table table-compact">
        <thead>
          <tr><th>Dès</th><th>Valeur</th><th>Statut</th>{onSupprimer && <th style={{ width: 32 }} />}</tr>
        </thead>
        <tbody>
          {lignes.slice().reverse().map((l) => (
            <tr key={l.id} title={l.commentaire}>
              <td className="tabular-nums">{fmtMoisFr(l.mois)}</td>
              <td className="tabular-nums">{l.valeur}</td>
              <td><BadgeTagRevenu tag={l.tag} scenarioNom={l.scenarioNom} /></td>
              {onSupprimer && (
                <td>
                  <button className="btn btn-icon" title="Supprimer l'événement" onClick={() => onSupprimer(l.id)}>
                    <Trash2 className="icon-sm" />
                  </button>
                </td>
              )}
            </tr>
          ))}
          {lignes.length === 0 && <tr><td colSpan={onSupprimer ? 4 : 3} className="text-ink-3">Aucun événement.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
